export const getTime = (milliseconds) => {
    const date = new Date(milliseconds);
    const daysInHours = (date.getDate() - 1) * 24; // convert day to hours
    const parseValue = value => String(value).length > 1 ? value : `0${value}`;

    const h = parseValue(daysInHours + date.getUTCHours());
    const m = parseValue(date.getUTCMinutes());
    const s = parseValue(date.getUTCSeconds());

    return `${h}:${m}:${s}`;
};

export const has18Years = dateOfBirth => hasYears(dateOfBirth, 18);

export const hasYears = (dateOfBirth, adultAge) => {
    const t = new Date(dateOfBirth);
    const y = t.getFullYear();
    const m = t.getMonth();
    const d = t.getUTCDate();

    return new Date(Date.UTC(y + adultAge, m, d + 1)).getTime() < new Date().getTime();
};

export const hasDaysDiffStrict = (from, until, diff) => {
    const y = from.getFullYear();
    const m = from.getMonth();
    const d = from.getDate();

    return new Date(y, m, d + diff).getTime() < until.getTime();
};

export const hasMonthDiff = (from, until, diff) => {
    const y = from.getFullYear();
    const m = from.getMonth();
    const d = from.getDate();

    return new Date(y, m + diff, d).getTime() <= until.getTime();
};

export const getTimeZone = () => new Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getMonthsBefore = (monthsCount, now = new Date()) => {
    const resultDay = new Date(now.getTime());

    resultDay.setDate(1);
    resultDay.setMonth(now.getMonth() - monthsCount);

    const daysInMonth = new Date(resultDay.getFullYear(), resultDay.getMonth() + 1, 0).getDate();

    if (daysInMonth < now.getDate()) {
        resultDay.setMonth(resultDay.getMonth() + 1);
    } else {
        resultDay.setDate(now.getDate());
    }

    return resultDay;
};

export const getFullHours = (date, isUTC) => {
    return String(isUTC ? date.getUTCHours() : date.getHours()).padStart(2, '0');
};

export const getFullMinutes = (date, isUTC) => {
    return String(isUTC ? date.getUTCMinutes() : date.getMinutes()).padStart(2, '0');
};

export const getStartOfTheDay = (date = new Date()) => {
    const startOfDate = new Date(date);

    startOfDate.setHours(0);
    startOfDate.setMinutes(0);
    startOfDate.setSeconds(0);
    startOfDate.setMilliseconds(0);

    return startOfDate;
};

export const getEndOfTheDay = (date = new Date()) => {
    const endOfDate = new Date(date);

    endOfDate.setHours(23);
    endOfDate.setMinutes(59);
    endOfDate.setSeconds(59);
    endOfDate.setMilliseconds(999);

    return endOfDate;
};

export const addDays = (date, count) => {
    const newDate = new Date(date);

    newDate.setDate(date.getDate() + count);

    return newDate;
};

export const minusDays = (date, count) => {
    return addDays(date, -count);
};
